import { primitives, semantics } from '@tui-cruises/mein-schiff-web-tailwind-config/dist/src/colors';

export const base = {
  ...primitives,
  // Neutrals
  white: '#FDFDFD',
  black: '#07152F',
  // Secondaries
  marine: {
    10: '#E9ECF0',
    20: '#D3D8E1',
    40: '#A8B2C3',
    60: '#7C8BA6',
    80: '#516588',
    100: '#263E6A',
  },
  // Primaries
  ocean: {
    10: '#F3FAFC',
    20: '#E7F5FA',
    40: '#D5ECF4',
    60: '#BEE3EE',
    80: '#A3D8E9',
    100: '#85CEE4',
    120: '#196894',
  },
  // States and Signals
  rose: {
    100: '#EBA6BD',
  },
  yellow: {
    100: '#FFF374',
  },
  success: {
    ...primitives.success,
    20: '#E1F4E6',
    100: '#387C4C',
    120: '#265734',
  },
  warning: {
    20: '#FDE1E0',
    120: '#782423',
  },
  attention: {
    ...primitives.attention,
    20: '#FFF1DB',
    100: '#F2B964',
    120: '#A07533',
  },
  error: {
    ...primitives.error,
    100: '#C44141',
  },
  destinations: {
    ...primitives.destination,
    'caribbean-central-america': '#BAA3B5',
    'north-america': '#B1B1D9',
    'nordland-great-britain': '#A7BABC',
    'dubai-orient': '#EAD250',
    'mediterranean': '#B1AB71',
    'asia': '#D49E7D',
    'baltic-sea-baltic-states': '#CCCEB4',
    'western-europe': '#A5AAA7',
    'canary-islands': '#D99997',
    'south-africa-namibia': '#DAC9AD',
    'nordland': '#80AEDC'
  },
  cruises: {
    ...primitives.cruise,
    'trans-journeys': '#C4CA74',
    'event-trips': '#EBBEB8',
    'mini-cruises': '#8EB2BB'
  },
  // Transparencies
  'black-transparent': {
    10: 'rgba(7, 21, 47, .1)',
    20: 'rgba(7, 21, 47, .2)',
    50: 'rgba(7, 21, 47, .5)',
    60: 'rgba(7, 21, 47, .6)',
    80: 'rgba(7, 21, 47, .8)',
  },
  'ocean-transparent': {
    60: 'rgba(133, 206, 228, .6)',
  },
};

export const semantic = {
  ...semantics,
  background: {
    'primary': base.ocean[10],
    'secondary': base.white,
    'tertiary': base.ocean[20],
  },
  text: {
    'high-emphasis': base.marine[100],
    'medium-emphasis': base.marine[80],
    'low-emphasis': base.marine[60],
    'on-dark': base.white,
    'disabled': base.marine[40],
  },
  stroke: {
    ...semantics.stroke,
    'primary-40': base.ocean[40],
    'primary-80': base.ocean[80],
    'primary-100': base.ocean[100],
    'secondary-20': base.marine[20],
    'secondary-40': base.marine[40],
    'secondary-60': base.marine[60],
    'secondary-100': base.marine[100],
  },
  control: {
    'selected': base.ocean[100],
    'inactive': base.marine[60],
  },
  signal: {
    ...primitives.signal,
    'yellow-100': base.yellow[100],
    'rose-100': base.rose[100],
  },

  // Adding flat versions
  // TODO: Migrate upper non-flat usages to flat usages

  // background
  'primary': base.ocean[10],
  'secondary': base.white,
  'tertiary': base.ocean[20],

  // text
  'high-emphasis': base.marine[100],
  'medium-emphasis': base.marine[80],
  'low-emphasis': base.marine[60],
  'on-dark': base.white,
  'disabled': base.marine[40],

  // stroke
  'primary-40': base.ocean[40],
  'primary-80': base.ocean[80],
  'primary-100': base.ocean[100],
  'secondary-20': base.marine[20],
  'secondary-40': base.marine[40],
  'secondary-60': base.marine[60],
  'secondary-100': base.marine[100],

  // control
  'selected': base.ocean[100],
  'inactive': base.marine[60],

  // signal
  'yellow-100': base.yellow[100],
  'rose-100': base.rose[100],
};
